import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {
    BigintDeliverableDisplayDecimalPipe
} from '../../components/bigint-display-decimal-pipe/bigint-deliverable-display-decimal.pipe';
import {CustomScrollbarModule} from '../../components/custom-scrollbar';
import {DisplayDecimalModule} from '../../components/display-decimal/index';
import {ElementRulerModule} from '../../components/element-ruler';
import {WIDGET_DESCRIPTIONS} from '../../components/layout/widget/widget-registry.service';
import {PartialLoadingIndicatorModule} from '../../components/partial-loading-indicator';
import {TablesModule} from '../../components/tables';
import {TooltipModule} from '../../components/tooltip';
import {L10nModule} from '../../components/translate';
import {TextHidingModule} from '../../directives/text-hiding';
import {DexDevRatesWidgetComponent} from './dex-dev-rates-widget.component';
import {DEX_DEV_RATES_WIDGET_DESCRIPTION} from './dex-dev-rates-widget.description';
import {DexDevRatesWidgetSettingsService} from './settings/dex-dev-rates-widget-settings.service';

@NgModule({
    imports: [
        CommonModule,
        CustomScrollbarModule,
        TablesModule,
        ElementRulerModule,
        L10nModule,
        TextHidingModule,
        PartialLoadingIndicatorModule,
        TooltipModule,
        DisplayDecimalModule,
        BigintDeliverableDisplayDecimalPipe
    ],
    declarations: [
        DexDevRatesWidgetComponent
    ],
    exports: [
        DexDevRatesWidgetComponent
    ],
    providers: [
        DexDevRatesWidgetSettingsService,
        {
            provide:  WIDGET_DESCRIPTIONS,
            useValue: DEX_DEV_RATES_WIDGET_DESCRIPTION,
            multi:    true
        }
    ]
})
export class DexDevRatesWidgetModule {}
